const custom_profile_fields = {
    /** UNTRANSLATED */
    entity_not_exists_with_names: 'Cannot find entities with the given names: {{names}}',
    invalid_min_max_input: 'إدخال الحد الأدنى أو الأقصى غير صالح.',
    invalid_options: 'خيارات الحقل غير صالحة.',
    invalid_regex_format: 'تنسيق التعبير النمطي غير صالح.',
    invalid_address_parts: 'أجزاء العنوان غير صالحة.',
    invalid_fullname_parts: 'أجزاء الاسم الكامل غير صالحة.',
    name_exists: 'هناك حقل بالفعل بهذا الاسم.',
    conflicted_sie_order: 'هناك تعارض في ترتيب الحقول لتجربة تسجيل الدخول.',
    /** UNTRANSLATED */
    invalid_name: 'Invalid field name, only letters or numbers are allowed, case sensitive.',
};
export default Object.freeze(custom_profile_fields);
